import styled from 'styled-components/macro'

import { theme, fluidSystem, mediaM } from 'styled'

import bgLeft from 'assets/bg-pattern-left.png'
import bgBottom from 'assets/bg-pattern-bottom.png'

export const Root = styled.div`
  ${fluidSystem};
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 160px;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 0;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 40%;
    background-image: url(${bgLeft});
    background-size: cover;
    z-index: -1;

    ${mediaM`
      width: 30%;
      height: 100%;
    `};
  }

  &:before {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 10%;
    background-image: url(${bgBottom});
    background-size: cover;
    z-index: -1;

    ${mediaM`
      width: 80%;
      height: 10%;
    `};
  }
`

export const ContentBox = styled.div`
  ${fluidSystem};
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 20px;

  ${mediaM`
    width: 50%;
    max-width: 800px;
    padding-left: 0;
    align-items: flex-start;
  `};
`

export const ResultBox = styled.div`
  ${fluidSystem};
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid rgba(221, 221, 221, 0.2);

  ${mediaM`
    flex-direction: row;
    justify-content: flex-start;
  `};
`

export const ResultCircle = styled.div`
  ${fluidSystem};
  flex: 0 0 auto;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid ${theme.colors.white};
  margin-bottom: 16px;

  ${mediaM`
    width: 146px;
    height: 146px;
    margin-bottom: 0;
  `};
`
